import { getAttributeRentalStatus } from "../../../sites/components/buildingAttributeStatus";
import { PlanAttributeRef } from "./planTypes";

export type LettingStatus = "rented" | "termination" | "vacant";

/**
 * Pins/contours are coloured by letting status for BOTH units and attributes, so a letting
 * responsible sees occupancy at a glance: green = Verhuurd, amber = In opzeg, red = Leegstaand.
 */
export const PLAN_STATUS_COLORS: Record<LettingStatus, string> = {
  rented: "#16a34a", // green  (Verhuurd)
  termination: "#d97706", // amber  (In opzeg)
  vacant: "#dc2626", // red    (Leegstaand)
};

export function statusColor(status: LettingStatus): string {
  return PLAN_STATUS_COLORS[status] || PLAN_STATUS_COLORS.vacant;
}

export function getAttributeColor(attribute: PlanAttributeRef | null | undefined): string {
  const status = getAttributeRentalStatus((attribute as any) || { contractProducts: [] });
  return statusColor(status as LettingStatus);
}
